import React, { useRef, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const validateEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const ContactContent = () => {
  const formRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const fd = new FormData(formRef.current);
    const name = fd.get('name').trim();
    const email = fd.get('email').trim();
    const message = fd.get('message').trim();

    if (!validateEmail(email)) {
      toast.error('Please enter a valid email address');
      setIsLoading(false);
      return;
    }

    try {
      const res = await fetch('/.netlify/functions/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message }),
      });

      if (!res.ok) throw new Error('Network error');

      toast.success(
        "Thank you for your message! We've sent a confirmation email."
      );
      formRef.current.reset();
    } catch (err) {
      console.error('Email sending failed:', err);
      toast.error('Failed to send your message. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <form
        ref={formRef}
        onSubmit={handleSubmit}
        className="flex flex-col gap-4 max-w-lg mx-auto"
      >
        <input
          name="name"
          type="text"
          placeholder="Name"
          required
          className="input-field"
        />
        <input
          name="email"
          type="email"
          placeholder="Email"
          required
          className="input-field"
        />
        <textarea
          name="message"
          placeholder="Message"
          rows={4}
          required
          className="input-field textarea"
        />
        <button
          type="submit"
          className="submit-button"
          disabled={isLoading}
        >
          {isLoading ? 'Sending…' : 'Submit'}
        </button>
      </form>

      <ToastContainer position="top-right" theme="dark" autoClose={5000} />
    </>
  );
};

export default ContactContent;
